import axios from "axios";
import { store } from "../store/store";
//for DEV/SIT code--start
// import {
//   authorizedURL,
//   clientIDs,
//   redirectURIs,
//   logoutURL,
//   clientSecreat,
// } from "../configSSO";
import { getCookie } from "../utils";

// let authorizeUrl = authorizedURL;
// let clientId = clientIDs;
// let redirectUri = redirectURIs;
// let grant_type = "authorization_code";

const getAuthenticationUrl = async () => {
  return `${process.env.REACT_APP_AUTHORIZED_URL}?response_type=code&client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_REDIRECT_URI}&grant_type=${process.env.REACT_APP_GRANT_TYPE}&scope=pingid+openid`;
};
const loginRedirect = async () => {
  console.log(
    "Your token has expired. The application will now redirect to the login page."
  );

  try {
    window.location = process.env.REACT_APP_LOGOUT_URL;
    // Adjust the delay time in milliseconds as needed (e.g., 2000 milliseconds or 2 seconds)
  } catch (error) {
    console.error("Error during login redirection:", error);
    // Handle the error, if needed
  }
};
//for DEV/SIT code--end

export default class Api {
  constructor() {
    this.axiosInstace = axios.create();
  }
  async init({
    headers = {
      "Access-Control-Allow-Headers": "Content-Type",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "OPTIONS,POST,GET",
    },
  }) {
    //for DEV/SIT code--start
    // const { token } = store.getState().AuthenticationReducer;
    // const tokenExpiryOn = getCookie("tokenExpiryON");
    // if (new Date().getTime() > tokenExpiryOn) {
    //   await loginRedirect();
    // } else {
    this.axiosInstace.interceptors.request.use(async (config) => {
      if (Object.keys(headers).length) {
        config.headers[headers.key] =
          headers.key === "If-Match" ? `"${headers.value}"` : headers.value;
      }
      // config.headers[
      //   "Authorization"
      // ] = `${token?.token_type} ${token?.access_token}`;
      // const tokenNumber= localStorage.getItem("tokenNumber");
      const tokenNumber =
        "eyJhbGciOiJSUzUxMiIsImtpZCI6IjEiLCJwaS5hdG0iOiI4OGJpIn0.eyJzY29wZSI6InBpbmdpZCBvcGVuaWQiLCJhdXRob3JpemF0aW9uX2RldGFpbHMiOltdLCJjbGllbnRfaWQiOiI1ZTAyNzRmMC03NTMxLTRmZjUtYjIyMC00ZTg1YTkxOTNmODQiLCJqdGkiOiJYNmFFWG9LUnAxTWV5M3pDWE85S2NnIiwidXNlckdyb3VwcyI6WyJjbj1HTE8tSW5kaWEsb3U9R3JvdXBzLG89d29ybGQiLCJjbj1ETlMtU2VsZlNlcnZpY2UtQUFDLG91PUdyb3VwcyxvPXdvcmxkIiwiY249Sk1QRy1MaWNlbmNlZFVzZXJzLG91PUdyb3VwcyxvPXdvcmxkIiwiY249T0VHRy1DQVNCX0dCUyxvdT1Hcm91cHMsbz13b3JsZCIsImNuPUFBQ0ctUk9MRS1BRE1JTixvdT1Hcm91cHMsbz13b3JsZCIsImNuPU9FR0ctQ0FTQl9SZXZlcnNlX1Byb3h5X1VzZXJzX05vbl9FbXBfQXV0b19Ob25fTkEsb3U9R3JvdXBzLG89d29ybGQiLCJjbj1TRUNHLUFNQS1OT05FTVBTLG91PUdyb3VwcyxvPXdvcmxkIiwiY249QUFDRy1ST0xFLVVTRVIsb3U9R3JvdXBzLG89d29ybGQiLCJjbj1ETlMtU2VsZlNlcnZpY2UtQXJ0d29ya0FnaWxpdHksb3U9R3JvdXBzLG89d29ybGQiLCJjbj1HU1ItUmVwLUFjY2VzcyxvdT1Hcm91cHMsbz13b3JsZCIsImNuPUdMT0ctbm9uLXBnLW90aGVycyxvdT1Hcm91cHMsbz13b3JsZCIsImNuPUdCU0ctQXZlUG9pbnQtUFJPRDQsb3U9R3JvdXBzLG89d29ybGQiLCJjbj1HQlNHLUFydHdvcmtfQWdpbGl0eV9TdWl0ZSxvdT1Hcm91cHMsbz13b3JsZCIsImNuPUdTUi1SZXAtRGVsZWdhdGVzLG91PUdyb3VwcyxvPXdvcmxkIiwiY249U0VDRy1BU0lBLU5PTkVNUFMsb3U9R3JvdXBzLG89d29ybGQiLCJjbj1HRFNHLUdpdGh1Yi1FbnRlcnByaXNlLVVzZXJzLG91PUdyb3VwcyxvPXdvcmxkIiwiY249R0xPRy1Ob24tRW1wLU90aGVyLG91PUdyb3VwcyxvPXdvcmxkIiwiY249U0VDRy1OT05FTVAtRU1FQSxvdT1Hcm91cHMsbz13b3JsZCIsImNuPUdMTy1OT04tUEcsb3U9R3JvdXBzLG89d29ybGQiLCJjbj1PRUctTzM2NV9FeGNlcHRpb25fR3JvdXAsb3U9R3JvdXBzLG89d29ybGQiLCJjbj1HTE8tTk9OUEcsb3U9R3JvdXBzLG89d29ybGQiLCJjbj1PUkctRXZlcnlvbmUtR0tDLG91PUdyb3VwcyxvPXdvcmxkIl0sIlVzZXIgaWQiOiJFUTA0OTEiLCJCVSI6IkdCVVNTIElEUSIsIlVzZXJuYW1lIjoic2hpa2FsZ2FyLm5zQHBnLmNvbSIsIkZpcnN0TmFtZSI6Ik5hdXppeWEiLCJDb3VudHJ5IjoiSW5kaWEiLCJSZWdpb24iOiJBTUEiLCJMYXN0TmFtZSI6IlNoaWthbGdhciIsIlVzZXIgZW1haWwiOiJzaGlrYWxnYXIubnNAcGcuY29tIiwiZXhwIjoxNzAxMjY0NDI4fQ.Rz1i0VBRSA4tyvryJY46XqKOs2pVzpqrUKnuOtNasHj8pSkWZXB2O1l7wdghAhAYEyxFPkjAmT4Sxkw7fFxbVzPmM6tGXHB57RkdnWx39R697cH9nPTPqrKMjhh6RbIRnc2CWn9aYtRg2mUEcCOFAUGHtrEgc5w6H_lhT1mUlhy8Q-BOghtIlh18mGnOoPpK7Ox0jWvVEwi0oWSes_vLxAKLVUGGu4CIejYysJ_I9QvwMq9COTSTIJ2R0q1NKT3DhtbPJPoi2KkhIaqnpsAcOdpA84tTpJXcpI9in5EiHID8TwFLAJsDDdTsEQhoMyUNwYl95XgqZ6iJeexQtWnokQ";

      config.headers["Authorization"] = `Bearer ${tokenNumber}`;

      return config;
    });
    // }
    //for DEV/SIT code--end

    //interceptors response
    this.axiosInstace.interceptors.response.use(
      (config) => {
        //validate response
        return config;
      },
      (error) => {
        console.log(error, "error");

        if (error?.response?.data === "Token Expired") {
          // window.location.href = `${redirectURIs}/logout`;
          //        async (error) => {
          try {
            //       // Refresh the token here
            const newToken = this.refreshAccessToken();

            //       // Update the Authorization header with the new token
            if (newToken) {
              const tokenNumber = newToken.access_token;
              localStorage.setItem("tokenNumber", tokenNumber);
              error.config.headers["Authorization"] = `Bearer ${tokenNumber}`;

              // Retry the original request with the new token
              return axios(error.config);
            }
          } catch (refreshError) {
            console.error("Error refreshing token:", refreshError);
            // Handle the case where token refresh fails, e.g., redirect to login page
            // or show an error message to the user
            // You may want to clear user sessions, redirect to login, etc.
            // depending on your application requirements.
          }

          //   // Handle other types of errors here

          //   // Throw the error to be caught by the calling function
          //   throw error;
          // }
        } else {
          store.dispatch({
            type: "API_ERROR",
            payload: error,
          });
          return error;
        }
      }
    );
    return this.axiosInstace;
  }
  // Function to refresh the access token using the refresh token
  async refreshAccessToken() {
    const refreshToken = localStorage.getItem("refreshToken"); // Replace with your actual storage method

    // Ensure you have a refresh token before attempting to refresh
    if (!refreshToken) {
      throw new Error("No refresh token available");
    }

    const data = new URLSearchParams();
    data.append("grant_type", "refresh_token");
    data.append("refresh_token", refreshToken);
    data.append("client_id", process.env.REACT_APP_CLIENT_ID);
    data.append("client_secret", process.env.REACT_APP_CLIENT_SECRET);

    try {
      const response = await fetch(
        "https://fedauthtst.pg.com/as/token.oauth2",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            // Add any additional headers as needed
          },
          body: data.toString(),
        }
      );

      if (!response.ok) {
        // Handle the case where token refresh fails
        throw new Error("Failed to refresh access token");
      } else {
        const newToken = await response.json();
        // Update the refresh token and access token in the storage
        localStorage.setItem("refreshToken", newToken.refresh_token);
        localStorage.setItem("tokenNumber", newToken.access_token);

        return newToken;
      }
    } catch (error) {
      console.error("Error refreshing token:", error);
      throw error;
    }
  }

  //   async generateToken() {
  //     const { user } = App.getStoreState();
  //     await this.getSSO();
  //     await this.getToken();
  //     this.getUserProfile()
  //   }

  //   async getSSO() {
  //     const { user } = App.getStoreState();
  //     if (user?.userInformation?.sso) {
  //       return user;
  //     } else {
  //       const { data: ssoRes } = await axios
  //         .get
  //         //any url to get sso
  //         ();
  //       App.dispatchToStore(userUpdateAction(ssoRes));
  //       return ssoRes;
  //     }
  //   }

  //   async getUserProfile() {
  //     const { token, user } = App.getStoreState();
  //     const form = new FormData();
  //     form.append('sso', user.userInformation.sso);
  //     form.append('first_name', user.userInformation.first_name);
  //     form.append('last_name', user.userInformation.last_name);
  //     form.append('role', user.userInformation.role);
  //     form.append('region', user.userInformation.region);

  //     let config = {
  //       url: `url to fetch profile details`,
  //       method: 'POST',
  //       data: form,
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }

  //     const ins = await this.init();
  //     const { data: userProfileInfo } = await ins(config)
  //     App.dispatchToStore(userProfileAction(userProfileInfo));
  //     return userProfileInfo;
  //   }
}
